<div class="instances-acess">
    <div class="subsection">
        <div class="section-toolbar">
            <span class="section-hint">Acessos por Instância (Global) — clique em uma instância para ver as ações</span>
            <nz-input-group class="filter-field" [nzPrefix]="searchIcon" [nzSuffix]="clearInstanceIcon">
                <input nz-input placeholder="Filtrar instâncias" [(ngModel)]="instanceInputFilter" (keyup)="updateFilterInstance()" />
            </nz-input-group>
            <ng-template #searchIcon><nz-icon nzType="search"></nz-icon></ng-template>
            <ng-template #clearInstanceIcon>
                <nz-icon *ngIf="instanceInputFilter" class="clear-icon" nzType="close-circle" nzTheme="fill" (click)="clearFilterInstance()"></nz-icon>
            </ng-template>
        </div>
        <div class="grid-box">
            <div class="grid-row grid-header cols-instances">
                <div>ID</div>
                <div>Instância</div>
                <div class="col-check">
                    <span>Visualizar</span>
                    <label nz-checkbox nz-tooltip="Marcar/desmarcar todos" [ngModel]="allChecked('view','V')" (ngModelChange)="toggleAll('view','V',$event)"></label>
                </div>
                <div class="col-check">
                    <span>Alterar</span>
                    <label nz-checkbox nz-tooltip="Marcar/desmarcar todos" [ngModel]="allChecked('change','A')" (ngModelChange)="toggleAll('change','A',$event)"></label>
                </div>
                <div class="col-check">
                    <span>Inserir</span>
                    <label nz-checkbox nz-tooltip="Marcar/desmarcar todos" [ngModel]="allChecked('insert','I')" (ngModelChange)="toggleAll('insert','I',$event)"></label>
                </div>
                <div class="col-check">
                    <span>Deletar</span>
                    <label nz-checkbox nz-tooltip="Marcar/desmarcar todos" [ngModel]="allChecked('delete','D')" (ngModelChange)="toggleAll('delete','D',$event)"></label>
                </div>
                <div class="col-check">
                    <span>Exportar</span>
                    <label nz-checkbox nz-tooltip="Marcar/desmarcar todos" [ngModel]="allChecked('export','E')" (ngModelChange)="toggleAll('export','E',$event)"></label>
                </div>
                <div class="col-check">
                    <span>Configurar</span>
                    <label nz-checkbox nz-tooltip="Marcar/desmarcar todos" [ngModel]="allChecked('config','C')" (ngModelChange)="toggleAll('config','C',$event)"></label>
                </div>
            </div>
            <nz-spin [nzSpinning]="loadingDataInstance" [nzTip]="applyingAll ? 'Aplicando permissões...' : null">
                <div class="rows-scroll viewport-instances">
                    <div class="grid-row cols-instances"
                        *ngFor="let instance of instanceAcessData"
                        [class.row-selected]="instance === selectedInstance"
                        (click)="selectInstance(instance)">
                        <div>{{instance.id}}</div>
                        <div class="cell-ellipsis" nz-tooltip [nzTooltipTitle]="instance.name">{{instance.name}}</div>
                        <div (click)="$event.stopPropagation()">
                            <nz-switch nzSize="small" [ngModel]="!!instance.view" [nzDisabled]="canPermite(instance,'V')"
                                (ngModelChange)="changeAcessInstance($event, 'V', instance)"></nz-switch>
                        </div>
                        <div (click)="$event.stopPropagation()">
                            <nz-switch nzSize="small" [ngModel]="!!instance.change" [nzDisabled]="canPermite(instance,'A')"
                                (ngModelChange)="changeAcessInstance($event, 'A', instance)"></nz-switch>
                        </div>
                        <div (click)="$event.stopPropagation()">
                            <nz-switch nzSize="small" [ngModel]="!!instance.insert" [nzDisabled]="canPermite(instance,'I')"
                                (ngModelChange)="changeAcessInstance($event, 'I', instance)"></nz-switch>
                        </div>
                        <div (click)="$event.stopPropagation()">
                            <nz-switch nzSize="small" [ngModel]="!!instance.delete" [nzDisabled]="canPermite(instance,'D')"
                                (ngModelChange)="changeAcessInstance($event, 'D', instance)"></nz-switch>
                        </div>
                        <div (click)="$event.stopPropagation()">
                            <nz-switch nzSize="small" [ngModel]="!!instance.export" [nzDisabled]="canPermite(instance,'E')"
                                (ngModelChange)="changeAcessInstance($event, 'E', instance)"></nz-switch>
                        </div>
                        <div (click)="$event.stopPropagation()">
                            <nz-switch nzSize="small" [ngModel]="!!instance.config" [nzDisabled]="canPermite(instance,'C')"
                                (ngModelChange)="changeAcessInstance($event, 'C', instance)"></nz-switch>
                        </div>
                    </div>
                    <nz-empty *ngIf="!loadingDataInstance && instanceAcessData.length === 0" nzNotFoundContent="Nenhuma instância encontrada"></nz-empty>
                </div>
            </nz-spin>
        </div>
    </div>

    <div class="subsection" *ngIf="selectedInstance != null">
        <div class="section-toolbar">
            <span class="section-hint">Ações (Global) — {{selectedInstance.name}}</span>
            <nz-input-group class="filter-field" [nzPrefix]="searchIcon2" [nzSuffix]="clearActionIcon">
                <input nz-input placeholder="Filtrar ações" [(ngModel)]="actionsInputFilter" (keyup)="updateFilterActions()" />
            </nz-input-group>
            <ng-template #searchIcon2><nz-icon nzType="search"></nz-icon></ng-template>
            <ng-template #clearActionIcon>
                <nz-icon *ngIf="actionsInputFilter" class="clear-icon" nzType="close-circle" nzTheme="fill" (click)="clearFilterActions()"></nz-icon>
            </ng-template>
        </div>
        <div class="grid-box">
            <div class="grid-row grid-header cols-actions">
                <div>ID</div>
                <div>Ação</div>
                <div>Expressão</div>
                <div>Permitido</div>
            </div>
            <nz-spin [nzSpinning]="loadingDataAction">
                <div class="rows-scroll viewport-actions">
                    <div class="grid-row cols-actions"
                        *ngFor="let acess of actionAcess"
                        [class.row-selected]="acess === selectedAction"
                        (click)="selectedAction = acess">
                        <div>{{acess.id}}</div>
                        <div class="cell-ellipsis" nz-tooltip [nzTooltipTitle]="acess.name">{{acess.name}}</div>
                        <div class="cell-ellipsis" nz-tooltip [nzTooltipTitle]="acess.expression">{{acess.expression}}</div>
                        <div (click)="$event.stopPropagation()">
                            <nz-switch nzSize="small" [ngModel]="!!acess.enable" [nzDisabled]="canPermite(acess,'AC')"
                                (ngModelChange)="changeAcessAction($event, acess)"></nz-switch>
                        </div>
                    </div>
                    <nz-empty *ngIf="!loadingDataAction && actionAcess.length === 0" nzNotFoundContent="Nenhuma ação encontrada"></nz-empty>
                </div>
            </nz-spin>
        </div>
    </div>
</div>
